// extracted by mini-css-extract-plugin
export default {"wrap":"HomeScreen_wrap__yoqVJ","otherCardsWrap":"HomeScreen_otherCardsWrap__-Tbng","marginWrap":"HomeScreen_marginWrap__HPaYd"};